import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimelineService {
  // Constants (like the AngularJS version)
  public readonly INCIDENT_EVENT = 1;
  public readonly EVENT = 2;
  public readonly VIDEO = 3;
  public readonly GLOBAL_INCIDENT = 4;
  public readonly SOCIAL_MEDIA = 5;
  public readonly NEW__TIMELINE_ENTITY = 'NEW__TIMELINE_ENTITY';
  public readonly NEW__TIMELINE_TIME = 'NEW__TIMELINE_TIME';
  public readonly PAUSE = 'PAUSE';
  public readonly START = 'START';
  public readonly TIMELINE_SWITCH = 'TIMELINE_SWITCH';

  public data = {
    showTimeline: false,
    showLiveTime: false,
    showMonitorTime: true,
    timelineItems: [] as any[],
  };

  private timelineEntitySubject = new Subject<any>();
  public timelineEntity$: Observable<any> = this.timelineEntitySubject.asObservable();

  private timelineTimeSubject = new Subject<Date>();
  public timelineTime$: Observable<Date> = this.timelineTimeSubject.asObservable();

  private pauseSubject = new Subject<void>();
  public pause$: Observable<void> = this.pauseSubject.asObservable();

  private startSubject = new Subject<void>();
  public start$: Observable<void> = this.startSubject.asObservable();

  private timelineSwitchSubject = new Subject<void>();
  public timelineSwitch$: Observable<void> = this.timelineSwitchSubject.asObservable();
  
  private alertReadSubject = new Subject<any>();
  public alertRead$: Observable<any> = this.alertReadSubject.asObservable();
  
  public timelineClick$ = new Subject<{ arcliveid: any, listid: any }>();
  public playbackComplete$ = new Subject<void>();

  constructor() {}
  public setTimelineByMode(mode: string): void {
    if (mode === 'Playback Mode') { 
      this.data.showTimeline = true;
      this.data.showLiveTime = false;
      this.data.showMonitorTime = false;
    } else if (mode === 'Monitor Mode') {
      this.data.showTimeline = false;
      this.data.showLiveTime = false;
      this.data.showMonitorTime = true;
    } else {
      this.data.showTimeline = false;
      this.data.showLiveTime = true;
      this.data.showMonitorTime = false;
    }
    this.timelineSwitchSubject.next();
  }

  public showLive(): void {
    this.data.showTimeline = false;
    this.data.showLiveTime = true;
    this.data.showMonitorTime = false;
  }

  public showPlayback(): void {
    this.data.showTimeline = true;
    this.data.showLiveTime = false;
    this.data.showMonitorTime = false;
  }

  public showMonitor(): void {
    this.data.showTimeline = false;
    this.data.showLiveTime = false;
    this.data.showMonitorTime = true;
  }

  public addVideoEventToTimeline(entity: any, img: string, listId: any, timestamp: number, timelineAlertId: any): void {
    const timelineEntity = { 
      entity: entity, 
      type: this.VIDEO, 
      img: img, 
      listId: listId, 
      timestamp: timestamp, 
      timelineAlertId: timelineAlertId 
    };
    this.data.timelineItems.push(timelineEntity);
    this.timelineEntitySubject.next(timelineEntity);
  }

  public addSMEventToTimeline(entity: any, img: string, listId: any, timestamp: number, timelineAlertId: any): void {
    const timelineEntity = { 
      entity: entity, 
      type: this.SOCIAL_MEDIA, 
      img: img, 
      listId: listId, 
      timestamp: timestamp, 
      timelineAlertId: timelineAlertId 
    };
    this.data.timelineItems.push(timelineEntity);
    this.timelineEntitySubject.next(timelineEntity);
  }

  public addItemEventToTimeline(entity: any, img: string, listId: any, timestamp: number, timelineAlertId: any): void {
    const timelineEntity = { 
      entity: entity, 
      type: this.EVENT, 
      img: img, 
      listId: listId, 
      timestamp: timestamp, 
      timelineAlertId: timelineAlertId 
    };
    this.data.timelineItems.push(timelineEntity);
    this.timelineEntitySubject.next(timelineEntity);
  }

  public addGIMEventToTimeline(entity: any, img: string, listId: any, timestamp: number, timelineAlertId: any): void {
    const timelineEntity = { 
      entity: entity, 
      type: this.GLOBAL_INCIDENT, 
      img: img, 
      listId: listId, 
      timestamp: timestamp, 
      timelineAlertId: timelineAlertId 
    };
    this.data.timelineItems.push(timelineEntity);
    this.timelineEntitySubject.next(timelineEntity);
  }

  public setTime(date: Date): void {
    this.timelineTimeSubject.next(date);
  }

  public pause(): void {
    this.pauseSubject.next();
  }

  public start(): void {
    this.startSubject.next();
  }

  public clearTimelineItems(): void {
    this.data.timelineItems = [];
  }

  public getTimelineItems(): any[] {
    return this.data.timelineItems;
  }

  public removeTimelineItem(itemToRemove: any): void {
    const index = this.data.timelineItems.findIndex(item => item === itemToRemove);
    if (index > -1) {
      this.data.timelineItems.splice(index, 1);
    }
  }
  
  public getTimelineState(): { showTimeline: boolean, showLiveTime: boolean, showMonitorTime: boolean } {
    return {
      showTimeline: this.data.showTimeline,
      showLiveTime: this.data.showLiveTime,
      showMonitorTime: this.data.showMonitorTime
    };
  }
}